/**
 *
 * AdministratorBCView
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as actions from './actions';
import AdministratorBCView from "./AdministratorBCView";

class AdministratorBCViewContainer extends React.PureComponent {

    componentWillMount() {
        const {params: {id}, handleParams} = this.props;
        if (id) {
            handleParams(id);
        }
    }

    render() {
        return (
            <AdministratorBCView {...this.props} />
        );
    }
}

AdministratorBCViewContainer.propTypes = {
    params: PropTypes.object,
    handleParams: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
    return {
        handleParams: (id) => dispatch(actions.handleParams(id)),
    };
}

export default connect(null, mapDispatchToProps)(AdministratorBCViewContainer);
